export class Course{
    id : number;
    courseCode : string;
    courseName : string; 
    courseYear : number;
} 